import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import T6 from '../../components/ExcerciseTypes/TypeIn/T6';

const json = {
  1: { // Exercise num
    unit: 'Unit 11',
    id: 'WB3-U11-P75-E1',
    audio: '',
    video: '',
    component: T6,
    stylesTextInput: { backgroundColor: 'transparent', border: 'none', padding: 0 },
    exerciseKey: 'img/FriendsPlus/Page75/E1/Key/answerKey.png',
    inputSize: 220,
    // titleImage: "img/FriendsPlus/Page60/E1/1.jpg",
    // titleQuestion: [{ num: '1', title: 'Read the sentences and number the picture.', color: "#5B5A5D" }],
    questionImage: [],
    questions: [
      {
        title: `
        <div style=" position: relative; ">
          <div> <img src='img/FriendsPlus/Page75/2.jpg' /> </div>
          <div style=" position: absolute; top: 152px; left: 202px; "><input id='0' /></div>
          <div style=" position: absolute; top: 203px; left: 203px; "><input id='1' /></div>
          <div style=" position: absolute; top: 254px; left: 202px; "><input id='2' /></div>
         
         
        </div>
        `,
        answer: [
          "smaller than",
          "shorter than",
          "taller than",

        ],
      },
    ],
  },
  2: {
    unit: 'Unit 11',
    id: 'WB3-U11-P75-E2',
    audio: '',
    video: '',
    component: D1,
    checkUppercase:true,
    titleImage: '',
    exerciseKey: 'img/FriendsPlus/Page75/E2/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page75/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page75/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page75/E2/3.jpg', input: true, answer: "smaller than" },
        { url: 'img/FriendsPlus/Page75/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page75/E2/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page75/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page75/E2/7.jpg', input: true, answer: "is taller than Billy" },
        { url: 'img/FriendsPlus/Page75/E2/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page75/E2/9.jpg' },
        { url: 'img/FriendsPlus/Page75/E2/10.jpg', input: true, answer: "is shorter than Rosy" },
        { url: 'img/FriendsPlus/Page75/E2/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page75/E2/12.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page75/E2/13.jpg' },
        { url: 'img/FriendsPlus/Page75/E2/14.jpg', input: true, answer: "bigger than a sandwich" },
        { url: 'img/FriendsPlus/Page75/E2/15.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page75/E2/16.jpg' },
        { url: 'img/FriendsPlus/Page75/E2/17.jpg', input: true, answer: "A sandwich is smaller than a pizza" },
        { url: 'img/FriendsPlus/Page75/E2/18.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page75/E2/19.jpg' },
      ],

    ]
  },




}
export default json;